
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getPlanList, editorPlan, getJobList, delPlan, delJob, getCheckList, editorJob, getJobCount,extendPlan,editProjectEventCheck } from '@/api/orderPolling';
import { UserModule } from '@/store/modules/user';

import DialogSelectUserPolling from './components/selectUserPolling.vue';
import { formatTime, parseTime } from '@/utils';
import eventBus from "@/utils/eventBus";
import SearchItem from './components/selectPollingSearch.vue';

@Component({
  name: 'OrderPollingList',
  components: {
    DialogSelectUserPolling,
    SearchItem
  },
  filters: {
    getOrderStatusName(val: any) {
      let name = ''
      if (parseInt(val) > 0 && parseInt(val) < 3) {
        name = '待处理'
      } else if (parseInt(val) === 3 || parseInt(val) === 5) {
        name = '进行中'
      } else if (parseInt(val) === 7 || parseInt(val) === 8) {
        name = '已完成'
      } else if (parseInt(val) === 9) {
        name = '已关闭'
      }
      return name;
    }
  }
})
export default class extends Vue {
  private activeName:any = 'first'
  private pagination = {
    total: 0,
    page: 1,
    size: 10
  }
  private tableData = []
  private searchParams: any = {};
  // 列表内容
  private columnItemData: any = [
    { name: '', value: '0', checked: false }, // 巡检计划名称
    { name: '巡检对象', value: '1', checked: true },
    { name: '任务描述', value: '2', checked: true },
    { name: '联系方式', value: '3', checked: true },
    { name: '地址', value: '4', checked: true },
    { name: '起始时间', value: '5', checked: true },
    { name: '频率', value: '6', checked: true },
    { name: '操作', value: '7', checked: true }
  ]
  private settingColumnItem = false
  private wheight = window.innerHeight - 150;
  created() {
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName
    }

    let body = document.documentElement || document.body;
    body.addEventListener('click', (e: any) => {
      if (e.target.id !== 'getColumnItemBtn') {
        this.settingColumnItem = false;
      }
    }, false);

    let that = this;
    eventBus.$on("orderPollingSearch", (data: any) => {
      that.searchParams = data;
      //搜索重围为页
      this.pagination.page=1;
      that.getPlanList();
    });

    this.getPlanList();
  }
  beforeDestroy() {
    eventBus.$off("orderPollingSearch");
  }

  // 获取巡检计划
  private getPlanList() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.page,
      size: this.pagination.size,
      ...this.searchParams,
    };
    getPlanList(params).then(res => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0;
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;
      this.pagination.total = 0;
      this.tableData = [];
    });
  }
  private handleCurrentChange(page:number) {
    this.pagination.page = page;
    this.getPlanList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.size = size;
    this.getPlanList();
  }
  private setColumnItem(val: any) {
    this.settingColumnItem = true;
  }
  private showHideColumn() {
    this.settingColumnItem = !this.settingColumnItem;
  }
  private handleClick(tab:any, event:any) {
    if (this.activeName === 'second') {
      //解决因计划延长 然后切换以巡检任务 日历数量不刷新问题
      this.getJobCount();
      this.getPlanTask(parseTime(new Date(this.timeSelected).getTime(), '{y}-{m}-{d}'));
    }
    if (this.activeName === 'first') {
      this.getPlanList();
    }
  }
  private detailDialog = false
  private activeDetailsName = 'first'
  private detailData = {}
  private detailPlan(current: any) {
    this.detailDialog = true;
    this.detailData = current;
  }
  // 计划
  private editPollingDialog = false
  private formEditPolling: any = {}
  private extendPollingDialog = false
  private formExtendPolling: any = {}
  private dialogSelectPolling = false
  private pollingType = 2
  private editPlan(val: any) {
    //判断当前秒级时间戳小于val里的end_day
    if (new Date().getTime() > val.end_day*1000 ) {
      this.showErrorMsg('巡检计划已结束，不能编辑');
      return;
    }
    this.formEditPolling = val;
    for (let index = 0; index < this.formEditPolling.start_time_list.length; index++) {
      let current = this.formEditPolling.start_time_list[index].start_time;
      if (typeof current === 'string') {
        let arr = this.formEditPolling.start_time_list[index].start_time.split(':');
        this.formEditPolling.start_time_list[index].start_time = new Date(2021, 12, 2, arr[0], arr[1]);
      }
    }
    this.editPollingDialog = true;
  }
  private handleExecutionTime() {
    this.formEditPolling.start_time_list.push({
      start_time: ''
    });
  }
  private handleDelExecutionTime(val:any) {
    let index = this.formEditPolling.start_time_list.indexOf(val);
    if (index !== -1) {
      this.formEditPolling.start_time_list.splice(index, 1);
    }
  }
  private openEngineer() {
    this.isTask = false;
    this.dialogSelectPolling = true;
  }
  private engineerChecked(val:any) {
    if (this.isTask) {
      if (!val.isDept) {
        let engList = val.engList;
        let str = '';
        if (engList) {
          engList.forEach((element1:any) => {
            str = str + element1.user_name + ' ';
          });
          this.activities[this.taskEngIndex].strEditWorkUser = str;
          this.activities[this.taskEngIndex].WorkUserList = engList;
        }
      }
    } else {
      if (val.isDept) {
        this.formEditPolling.servicer_work_user_list = [];
        this.formEditPolling.servicer_dept_id = val.servicer_dept_id;
        this.formEditPolling.servicer_dept_name = val.servicer_dept_name;
      } else {
        this.formEditPolling.servicer_dept_id = '';
        this.formEditPolling.servicer_dept_name = '';
        this.formEditPolling.servicer_work_user_list = val.engList;
      }
    }
  }
  private closeSelectPolling(val: any) {
    this.dialogSelectPolling = val;
  }
  private engineerClose(index:number) {
    this.formEditPolling.servicer_work_user_list.splice(index, 1);
  }
  private deptClose() {
    this.formEditPolling.servicer_dept_id = '';
    this.formEditPolling.servicer_dept_name = '';
  }
  private editPollingConform() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;

    if (this.formEditPolling && this.formEditPolling.start_time_list && this.formEditPolling.start_time_list.length > 0) {
      let sTimes:any = [];
      for (let index = 0; index < this.formEditPolling.start_time_list.length; index++) {
        let sTime:any = {};
        const element = this.formEditPolling.start_time_list[index];
        sTime.start_time = parseTime(new Date(element.start_time).getTime(), '{h}:{i}');
        sTimes.push(sTime);
      }
      pamars.execution_time = JSON.stringify(sTimes);
    }
    pamars.project_name = this.formEditPolling.project_name;

    if (this.formEditPolling && this.formEditPolling.servicer_work_user_list && this.formEditPolling.servicer_work_user_list.length > 0) {
      let engList:any = [];
      this.formEditPolling.servicer_work_user_list.forEach((element:any) => {
        let eng:any = {};
        eng.user_id = element.user_id ? element.user_id : element.id;
        eng.user_name = element.user_name ? element.user_name : element.name;
        eng.dept_id = element.dept_id;
        eng.dept_name = element.dept_name;

        //修改工程师 其对应的订单服务部门也需要修改 与添加一致
        pamars.servicer_dept_id = element.dept_id;
        pamars.servicer_dept_name = element.dept_name;

        engList.push(eng);
      });
      pamars.engineer = JSON.stringify(engList);
    } else {
      pamars.servicer_dept_id = this.formEditPolling.servicer_dept_id;
      pamars.servicer_dept_name = this.formEditPolling.servicer_dept_name;
    }
    pamars.project_id = this.formEditPolling.id;
    editorPlan(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getPlanList();
      this.editPollingDialog = false;
      this.jumpImportTask();
      setTimeout(() => {
        this.getPlanList();
      }, 3000)
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private handleExtendPlanDiaog(val: any) {
    this.formExtendPolling = val;
    this.extendPollingDialog = true;
  }
  private handleExtendPollingConfirm(){
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    // pamars. = formExtendPolling ;
    //判断延长时间是否小于现有日期
    if(!this.formExtendPolling.date){
      this.showErrorMsg("请设置延长时间");
      return;
    }
    pamars.extend_end_day = this.formExtendPolling.date;
    pamars.project_id = this.formExtendPolling.id;
    extendPlan(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getPlanList();
      this.extendPollingDialog = false;

      this.jumpImportTask();
      setTimeout(() => {
        this.getPlanList();
      }, 3000)

    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }


  // 批量延长
  private multipleSelection = []
  private tableSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  
  private handleBatchExtendPlanDiaog() {
    if (this.multipleSelection.length === 0) {
      this.showErrorMsg('请选择需要延长的计划');
      return;
    }
   
    //将multipleSelection数组的内容取出用豆号联接
    let projectIdArr:any = [];
    this.multipleSelection.forEach((ss:any) => {
      projectIdArr.push(ss.id);
    });
    const  projectIds = projectIdArr.join();
    this.formExtendPolling = {id:projectIds};
    this.extendPollingDialog = true;
  }
  //修改检查项
  private checkListItem: any = [{
    name: '状态',
    radio: -1,
    isDiagonal: false,
    configUnusual: false

  }, {
    name: '描述',
    radio: -1,
    isDiagonal: true,
    configUnusual: false
  }, {
    name: '当前值',
    radio: -1,
    isDiagonal: true,
    configUnusual: false
  }, {
    name: '照片',
    radio: -1,
    isDiagonal: true,
    configUnusual: false
  }]

  private editPollingEventCheckDialog = false
  private formPollingEventCheckPolling: any = {}
  private handleEditPollingEventCheckDiaog(val: any,project: any) {

    if (new Date().getTime() > project.end_day*1000 ) {
      this.showErrorMsg('巡检计划已结束，不能修改');
      return;
    }

    val.project_id = project.id;
    this.formPollingEventCheckPolling = val;
    this.editPollingEventCheckDialog = true;
   
    this.checkListItem[0].radio = parseInt(val.state_config);
    this.checkListItem[1].radio = parseInt(val.text_config);
    this.checkListItem[2].radio = parseInt(val.value_config);
    this.checkListItem[3].radio = parseInt(val.image_config);
    this.checkListItem[1].configUnusual = parseInt(val.text_config_abnormal_is_required) === 1;
    this.checkListItem[2].configUnusual = parseInt(val.value_config_abnormal_is_required) === 1;
    this.checkListItem[3].configUnusual = parseInt(val.image_config_abnormal_is_required) === 1;

    // this.formCheck = {
    //   name: val.name,
    //   explain: val.statement,
    //   unit: val.unit,
    //   id: val.id
    // };


  }
  private handleEditPollingEventCheckConfirm(){
    let pamars:any = {};
    
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;

    pamars.project_id = this.formPollingEventCheckPolling.project_id;
    pamars.event_id = this.formPollingEventCheckPolling.event_id;
    pamars.check_id = this.formPollingEventCheckPolling.check_id;

    pamars.id = this.formPollingEventCheckPolling.id;

    pamars.state_config  = this.checkListItem[0].radio ;
    pamars.text_config =this.checkListItem[1].radio ;
    pamars.value_config =this.checkListItem[2].radio ;
    pamars.image_config =this.checkListItem[3].radio ;
    pamars.text_config_abnormal_is_required= this.checkListItem[1].configUnusual && parseInt(pamars.text_config) == 2 ? 1 : 0;
    pamars.value_config_abnormal_is_required= this.checkListItem[2].configUnusual && parseInt(pamars.value_config) == 2 ? 1 : 0;
    pamars.image_config_abnormal_is_required =this.checkListItem[3].configUnusual && parseInt(pamars.image_config) == 2 ? 1 : 0;
    // pamars. = formExtendPolling ;
    //判断延长时间是否小于现有日期
    // if(!this.formExtendPolling.date){
    //   this.showErrorMsg("请设置延长时间");
    //   return;
    // }
    // pamars.extend_end_day = this.formExtendPolling.date;

    editProjectEventCheck(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getPlanList();
      this.editPollingEventCheckDialog = false;
      //不关闭详情弹窗
      // this.detailDialog = false;
      // this.jumpImportTask();
      // setTimeout(() => {
      //   this.getPlanList();
      // }, 3000)

    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  

  //任务
  private jumpImportTask() {
    let routeData = this.$router.resolve({
      path: '/ImportTask',
      query: {}
    });
    window.open(routeData.href);
  }

  private deletePlan(val:any) {
    this.$confirm('确认删除巡检计划及计划下未执行的巡检任务！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.delPlan(val);
    }).catch(() => {

    });
  }
  private delPlan(val:any) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.project_id = val.id;
    delPlan(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getPlanList();
      //解决因计划延长 然后切换以巡检任务 日历数量不刷新问题
      this.getJobCount();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 任务
  private loading=false
  private timeSelected = new Date()
  private reverse = true
  private activities: any = [];
  private jobDayList = [];// 有巡检事件的时间数组

  private getJobCount() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.date = parseTime(new Date(this.timeSelected).getTime(), '{y}-{m}');
    getJobCount(pamars).then(res => {
      if (res.data) {
        this.jobDayList = res.data.list;
      } else {
        this.jobDayList = [];
      }
    }).catch(err => {
      this.jobDayList = [];
      let msg = err.msg
    });
  }
  private momth=''
  private currentDateShow = ''
  private currentWeekShow = ''
  private currentOver: number = 0
  private getPlanTask(val: any) {
    // this.getJobCount();
    this.currentDateShow = parseInt((new Date(val).getMonth() as any) + 1) + '月' + new Date(val).getDate() + '日';
    switch (new Date(val).getDay()) {
      case 0:
        this.currentWeekShow = '周日'
        break;
      case 1:
        this.currentWeekShow = '周一'
        break;
      case 2:
        this.currentWeekShow = '周二'
        break;
      case 3:
        this.currentWeekShow = '周三'
        break;
      case 4:
        this.currentWeekShow = '周四'
        break;
      case 5:
        this.currentWeekShow = '周五'
        break;
      case 6:
        this.currentWeekShow = '周六'
        break;
    }
    let countOver: number = 0
    if (val.split('-')[1] !== this.momth) {
      this.momth = val.split('-')[1];
      this.getJobCount();
    }
    this.loading = true;
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.job_time = val;
    pamars.page = 1;
    pamars.size = 999;
    getJobList(pamars).then(res => {
      this.loading = false;
      if (res.data) {
        this.activities = res.data.list;
        for (let i = 0; i < this.activities.length; i++) {
          let cont = this.activities[i].isShow;
          this.$set(this.activities, cont, false)
          if (parseInt(this.activities[i].order_state) >= 7) {
            countOver++;
          }
        }
        this.currentOver = countOver;
        for (let index = 0; index < this.activities.length; index++) {
          const element = this.activities[index];
          let str = '';
          if (element.format_servicer_work_user_data) {
            element.format_servicer_work_user_data.forEach((element1:any) => {
              str = str + element1.user_name + ' ';
            });
            this.activities[index].strWorkUser = str;
          }
        }
      } else {
        this.currentOver = 0;
        this.activities = [];
      }
    }).catch(err => {
      this.currentOver = 0;
      this.activities = [];
      let msg = err.msg;
      this.loading = false;
    });
  }
  private togglePollingShow(val: any) {
    if (this.activities[val].isShow) {
      this.$set(this.activities[val], 'isShow', false)
    } else {
      this.$set(this.activities[val], 'isShow', true)
    }
  }
  private checkLock(val:any) {
    this.$router.push({
      path: '/OrderServicer/all',
      query: { 'order_id': val }
    });
  }

  private dialogDeletePollingVisible=false
  private pollingDelete= '1'
  private itemDelete: any = ''
  private delTaskHandl(val:any) {
    this.dialogDeletePollingVisible = true;
    this.itemDelete = val;
  }
  private confirmDelete() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.job_id = this.itemDelete.id;
    pamars.delete_type = this.pollingDelete;
    delJob(pamars).then((res:any) => {
      this.dialogDeletePollingVisible = false;
      this.showSecussMsg(res.msg);
      this.momth = '';
      this.getPlanTask(parseTime(new Date(this.timeSelected).getTime(), '{y}-{m}-{d}'));
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private editListHandle(item: any, index:number) {
    let executionPickTime :any = '';
    if (typeof item.execution_time === 'string') {
      let arr = item.execution_time.split(':');
      executionPickTime = new Date(2021, 12, 2, arr[0], arr[1]);
    }
    this.$set(this.activities[index], 'executionPickTime', executionPickTime);
    this.$set(this.activities[index], 'strEditWorkUser', item.strWorkUser);

    this.$set(this.activities[index], 'isEditData', true);
  }
  private cancelEditHandle(item: any, index:number) {
    this.$set(this.activities[index], 'isEditData', false);
  }
  private isTask=false;
  private taskEngIndex:any=''
  private selectEngineer(index:any) {
    this.taskEngIndex = index;
    this.isTask = true;
    this.formEditPolling = {};
    this.dialogSelectPolling = true;
  }
  private saveTask(val:any, index:number) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.job_id = val.id;
    pamars.edit_type = 1;
    if (val.executionPickTime) {
      let str:any = parseTime(val.executionPickTime, '{h}-{i}');
      let arr = str.split('-');
      pamars.change_hour = arr[0];
      pamars.change_minute = arr[1];
    }
    if (val.WorkUserList && val.WorkUserList.length > 0) {
      let engArr:any = [];
      val.WorkUserList.forEach((element:any) => {
        let eng:any = {};
        eng.user_id = element.user_id;
        eng.user_name = element.user_name;
        engArr.push(eng);
      });
      pamars.engineer = JSON.stringify(engArr);
    }
    editorJob(pamars).then((res:any) => {
      this.$set(this.activities[index], 'isEditData', false);
      this.showSecussMsg(res.msg);
      this.getPlanTask(parseTime(new Date(this.timeSelected).getTime(), '{y}-{m}-{d}'));
    }).catch(err => {
      this.showErrorMsg(err.msg);
      this.$set(this.activities[index], 'isEditData', false);
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
